import React, { useRef, useState, useEffect, useContext } from "react";
import { FaArrowLeft, FaSearch, FaPaperPlane, FaTrash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import MessageAlert from "../../../components/messageAlert";
import Loader from "../../../components/loader";
import axios from "axios";
import buildLink from "../../../urls";
import { PlaySounds } from "../../../functions/playSounds";
import { CompanyContext } from "../../../contexts/companyCotext";
import Select from "react-select";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import SingleProduct from "../../../components/SingleProduct";
import ReactPaginate from "react-paginate";
import Header from "../../../components/Header";
import { axiosServer } from "../../../axiosServer";

const WareHouseStudioRestock = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();

  const [warehouses, setWarehouses] = useState([]);
  const [inputQuantity, setInputQuantity] = useState("");
  const [address, setAddress] = useState("");
  const [reference, setReference] = useState("");
  const [realaddress, setRealAddress] = useState("");
  const [addresstype, setSelectAddressType] = useState("bin");

  const [loadingSearch1, setLoadingSearch1] = useState(false);
  const [loadingSearch2, setLoadingSearch2] = useState(false);
  const [loadingSearch3, setLoadingSearch3] = useState(false);
  const [error, setError] = useState(null);
  const AddressID = useRef(null);
  const [addressText, setAddressText] = useState('')
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [ProductInfo, setProductInfo] = useState([]);
  const [CounterTemp, setCounterTemp] = useState(0);
  const [userID, setUserID] = useState(null);
  const { name, id } = useParams();
  const decodedName = decodeURIComponent(name);
  const [status, setstatus] = useState(0);
  const [status2, setstatus2] = useState("");
  const [towarehouse, settowarehouse] = useState({
    warehouse_id: "",
    warehouse_name: ""
  });
  const [fromwarehouse, setfromwarehouse] = useState({
    warehouse_id: "",
    warehouse_name: ""
  });

  const inputQuantityy = useRef(null);
  const [objectFromCookies, setObjFromCookies] = useState(null);
  const productID = useRef(null);
  const orderId = useRef(null)

  useEffect(() => {
    const user_id = localStorage.getItem("userID");
    setUserID(user_id);
  }, []);

  const fetchReceivedProducts = async () => {
    try {
      const url = buildLink(`fetchReceivedWarehouseProducts`);
      const response = await axiosServer.get(url);
      if (response.data.success) {
        setWarehouses(response.data.data || []);
      } else {
        setError("Failed to fetch warehouses.");
      }
    } catch (err) {
      setError("Failed to fetch warehouses.");
    }
  };


  const getWarehouseData = (from_id, to_id) => {
    const warehouse_from = warehouses.find((w) => w.warehouse_id === from_id);
    if (warehouse_from) {
      setfromwarehouse(warehouse_from);
    }


    const warehouse_to = warehouses.find((w) => w.warehouse_id === to_id);
    if (warehouse_to) {
      settowarehouse(warehouse_to);
    }
  }


  useEffect(() => {
    if (objectFromCookies) {
      if (objectFromCookies.selectedWarehousefrom && warehouses) {
        setfromwarehouse(objectFromCookies.selectedWarehousefrom);
      }
      if (objectFromCookies.selectedWarehouseto && warehouses) {
        settowarehouse(objectFromCookies.selectedWarehouseto);
      }
    }
  }, [warehouses, objectFromCookies]);

  useEffect(() => {
    setstatus(8);
    setstatus2(8);
  }, []);

  const clearInputs = () => {
    productID.current.value = "";
    setAddress("");
    setReference("");
    setInputQuantity("");
    AddressID.current.value = "";
  };

  useEffect(() => {
    const response = Cookies.get(decodedName);
    if (response) {

      setObjFromCookies(JSON.parse(response));
      // console.log(response);
    }

    fetchReceivedProducts();
  }, []);

  const getTransferOrderByIdStudio = async (e) => {
    e.preventDefault();
    setLoadingSearch1(true);
    const order_id = orderId.current.value;

    const url = buildLink("getTransferOrderByIdStudio") + `&order_id=${order_id}` + `&status=8`;

    try {
      const response = await axiosServer.get(url);
      if (response.data.success) {
        playSuccessSound();
        setMessage("Success");
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
        setRealAddress(
          response.data.products.bin_id || response.data.products.upc
        );
        setProductInfo(response.data.products)
        setAddress(response.data.products.address);
        setReference(response.data.products.upc);
        getWarehouseData(response.data.from_warehouse, response.data.to_warehouse);
      } else {
        playErrorSound();
        setMessage(response.data.message);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
      }
    } catch (error) {
      playErrorSound();
      setLoadingSearch1(false);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setMessage(error.response.data.message);
      } else {
        setMessage("An unknown error occurred");
      }

      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    } finally {
      setLoadingSearch1(false);
    }
  }

  const getProductAddressStudio = async (e) => {
    e.preventDefault()
    setLoadingSearch2(true);
    let product_id = productID.current.value;
    let order_id = orderId.current.value

    const url =
      buildLink("getProductAddressStudio") + `&product_id=${product_id}` + `&order_id=${order_id}`;

    try {
      const response = await axiosServer.get(url);

      if (response.data.success) {
        playSuccessSound();
        setMessage("Success");
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);

        setAddressText(response.data.address);
      } else {
        playErrorSound();
        setMessage(response.data.message);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
      }
    } catch (error) {
      playErrorSound();
      setLoadingSearch2(false);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setMessage(error.response.data.message);
      } else {
        setMessage("An unknown error occurred");
      }

      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    } finally {
      setLoadingSearch2(false);
    }

  }

  const getTransferOrderByProduct = async (e) => {
    e.preventDefault(); // Prevent the page from refreshing
    setLoadingSearch2(true);
    const item = productID.current.value; // Get the product ID


    const url =
      buildLink("getTransferOrderByProduct") + `&product=${item}` + `&status=8`;

    try {
      const response = await axiosServer.get(url);

      if (response.data.success) {
        playSuccessSound();
        setMessage("Success");
        setShowMessageSucc(true);
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
        settowarehouse(response.data.to_warehouse);
        setfromwarehouse(response.data.from_warehouse);
        const addressValue = response.data.products?.address || response.data.address;
        setAddressText(addressValue);
        if (isGhana) {
          orderId.current.value = response?.data?.order_id;
        }
        getWarehouseData(response.data.from_warehouse, response.data.to_warehouse);
      } else {
        playErrorSound();
        setMessage(response.data.message);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
      }
    } catch (error) {
      playErrorSound();
      setLoadingSearch2(false);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setMessage(error.response.data.message);
      } else {
        setMessage("An unknown error occurred");
      }

      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    } finally {
      setLoadingSearch2(false);
    }
  };

  const changestatus = async (e) => {
    e.preventDefault();
    let productIdTemp = productID.current.value || "";
    const address_id = AddressID.current.value || "";
    const quantity = inputQuantity;
    const address_type = "bin";
    const to_warehouse = towarehouse;
    const from_warehouse = fromwarehouse;
    const orderID = orderId?.current?.value || "";
    const user_id = userID;
    if (!productIdTemp || !address_id || !quantity) {
      // Check if all the required fields are filled
      setMessage(
        "Please fill in all the required fields: Product, Address, Quantity."
      );
      setShowMessageErr(true);
      setTimeout(() => setShowMessageErr(false), 10000);
      return;
    }
    if (inputQuantity <= 0) {
      setMessage("Quantity Must Be greater than 0");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    if (CounterTemp < 30 && CounterTemp - 1 > 0) {
      setCounterTemp(CounterTemp - 1);
    } else {
      setLoadingSearch3(true);
      try {
        const obj = {
          address_type,
          order_id: orderID,
          to_warehouse: to_warehouse.warehouse_id,
          from_warehouse: from_warehouse.warehouse_id,
          quantity
        };

        if (isGhana) {
          obj['product_id'] = productIdTemp;
          obj['address'] = address_id;
        } else {
          obj['product'] = productIdTemp;
          obj['address_id'] = address_id;
          obj['user_id'] = user_id;
          obj['status'] = status;
        }


        let url = "";
        if (isGhana) {
          url = buildLink("restockStudioGhana");
        } else {
          url = buildLink("changeProductStatus");
        }
        const response = await axiosServer.post(url, obj);

        if (response.data.success) {
          setLoadingSearch3(false);
          setMessage("Product updated successfully");
          playSuccessSound();
          setShowMessageSucc(true);
          setTimeout(() => setShowMessageSucc(false), 10000);
          setRealAddress("");
          setAddress("");
          if (ProductInfo.length - 1 === 0) {
            orderId.current.value = ""
            setfromwarehouse({
              warehouse_id: "",
              warehouse_name: ""
            })
            settowarehouse({
              warehouse_id: "",
              warehouse_name: ""
            })
          }
          setProductInfo((prevInfo) => prevInfo.filter((prod) => prod.product_id !== productIdTemp));
          setAddressText("")
          setReference("");
          productID.current.value = "";
          AddressID.current.value = "";
          setInputQuantity("");
        } else {
          setLoadingSearch3(false);
          setMessage(response?.data?.message || "Error");
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
          playErrorSound();
        }
      } catch (e) {
        setLoadingSearch3(false);
        console.log(e);
        setMessage(e.response?.data?.message);
        setShowMessageErr(true);
        setTimeout(() => setShowMessageErr(false), 10000);
        clearInputs();
      }
    }
  };

  const handleTrashClick = (type) => {
    if (type === "product") {
      productID.current.value = "";
      productID.current.focus();
    } else if (type === "order") {
      orderId.current.value = "";
      orderId.current.focus();
    }

  };

  const host = window.location.host;
  const isGhana = host == "pda.ishtari.com.gh";


  return (
    <div className="overflow-hidden h-screen">
      <div className="mb-5 sticky top-0 flex flex-col bg-white z-50 shadow-md">
        <Header title={"WareHouse Studio Restock"} />
      </div>

      <div className="container overflow-auto max-h-[calc(100vh-4rem)] px-4 py-6">
        {" "}
        {/* Allow scrolling and reduce max height by header size */}
        {/* Form Inputs */}
        <div className="container mx-auto">

          {isGhana && (
            <>
              {/* Product Id */}
              <form onSubmit={(e) => getTransferOrderByIdStudio(e)}>
                <div className="flex flex-col">
                  <div className="mb-1">Transfer ID</div>
                  <div className="flex flex-row border-dblack rounded-lg text-center w-full gap-3">
                    <div className="relative flex flex-row border-dblack rounded-lg text-center w-full gap-3">
                      <input
                        ref={orderId}
                        type="text"
                        className="border border-dblack rounded-lg block p-2 flex-grow text-start w-full h-12 pr-10"
                        placeholder="Transfer ID"
                      />
                      <FaTrash
                        onClick={() => handleTrashClick("order")}
                        className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                      />
                    </div>

                    <button className="border border-dblack bg-dbase rounded-lg text-white px-5 h-12">
                      {loadingSearch1 ? <Loader /> : <FaSearch />}
                    </button>
                  </div>
                </div>
              </form>
            </>
          )}

          {isGhana && (
            <>
              <div className="mt-3">
                <div className="mb-1">From Warehouse</div>
                <input
                  type="text"
                  readOnly
                  placeholder="From Warehouse"
                  value={fromwarehouse.warehouse_name}
                  className="border border-dblack rounded-lg block p-2.5 flex-grow text-start w-full h-12"
                />
              </div>
              <div className="mt-3">
                <div className="mb-1">To Warehouse</div>
                <input
                  type="text"
                  readOnly
                  placeholder="To Warehouse"
                  value={towarehouse.warehouse_name}
                  className="border border-dblack rounded-lg block p-2.5 flex-grow text-start w-full h-12"
                />
              </div>
            </>
          )}



          {/* Product Id */}
          <form onSubmit={(e) => {
            if (isGhana) {
              getProductAddressStudio(e)
            } else {
              getTransferOrderByProduct(e)
            }
          }}>
            <div className="flex flex-col mt-3">
              <div className="mb-1">Product ID or SKU</div>
              <div className="flex flex-row border-dblack rounded-lg text-center w-full gap-3">
                <div className="relative flex flex-row border-dblack rounded-lg text-center w-full gap-3">
                  <input
                    ref={productID}
                    type="text"
                    className="border border-dblack rounded-lg block p-2 flex-grow text-start w-full h-12 pr-10"
                    placeholder="Product ID or SKU"
                  />
                  <FaTrash
                    onClick={() => handleTrashClick("product")}
                    className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                  />
                </div>

                <button className="border border-dblack bg-dbase rounded-lg text-white px-5 h-12">
                  {loadingSearch2 ? <Loader /> : <FaSearch />}
                </button>
              </div>
            </div>
          </form>

          {!isGhana && (
            <div className="mt-3">
              <div className="mb-1">To Warehouse</div>
              <input
                type="text"
                readOnly
                placeholder="To Warehouse"
                value={towarehouse.warehouse_name}
                className="border border-dblack rounded-lg block p-2.5 flex-grow text-start w-full h-12"
              />
            </div>
          )}

          {addressText && (
            <p className="font-bold text-dblack mt-3">
              Address: {addressText}
            </p>
          )}

          {/* <div className="py-2">
            <div className="mb-1">Address Type</div>
            <Select
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "7px",
                  borderColor: state.isFocused ? "grey" : "grey",
                  padding: "8px 5px",
                }),
              }}
              value={{
                value: addresstype,
                label:
                  addresstype.charAt(0).toUpperCase() + addresstype.slice(1),
              }}
              onChange={(selectedOption) =>
                setSelectAddressType(selectedOption.value)
              }
              options={[
                { value: "bin", label: "Bin" },
                { value: "reference", label: "Reference" },
              ]}
              defaultValue={{ value: "bin", label: "Bin" }}
              placeholder="Select Warehouse"
              className="w-full"
            />
          </div> */}

          <div className="flex flex-col mt-3">
            <div className="flex mb-1">
              <span className="mr-2">Address:</span>
              <span>{address}</span>
              {reference !== "" && (
                <>
                  <span className="ml-1 mr-1">Reference:</span>
                  <span>{reference}</span>
                </>
              )}
            </div>

            <div className="flex flex-row border-dblack rounded-lg text-center w-full gap-3">
              <input
                ref={AddressID}
                type="text"
                className="border border-dblack rounded-lg block p-2.5 flex-grow text-start w-full h-12"
                placeholder="Address ID"
              />
            </div>
          </div>
          {/* Quantity Form */}
          <form onSubmit={changestatus}>
            <div className="flex flex-col">
              <div className="py-3">
                <div className="mb-1">Quantity</div>
                <div className="flex items-center gap-3">
                  <input
                    required
                    type="number"
                    min={1}
                    value={inputQuantity}
                    ref={inputQuantityy}
                    onChange={(e) => {
                      const quantity = e.target.value;
                      setInputQuantity(quantity);
                      setCounterTemp(quantity);
                    }}
                    placeholder="Quantity to Transfer"
                    className="border p-2 rounded-md w-full h-12"
                  />
                </div>

                {inputQuantity > 0 && (
                  <div className="mt-2 text-lg font-semibold">
                    Counter: {CounterTemp}
                  </div>
                )}
              </div>
              <button
                type="submit"
                className="bg-dbase rounded-md mt-5 text-white px-5 py-3 flex justify-center items-center"
                disabled={loadingSearch3}
              >
                {loadingSearch3 ? <Loader /> : <FaPaperPlane />}
              </button>
            </div>
          </form>
        </div>

        {isGhana && (
          <div className="mt-5 px-6 pb-2">
            {/* Table Section */}
            <h3 className="text-lg font-semibold mb-3">Order Products</h3>
            <table className="w-full table-auto border-collapse border">
              <thead>
                <tr className="border-b">
                  <th className="px-4 py-2 border-r">Product ID</th>
                  <th className="px-4 py-2 border-r">Quantity</th>
                  <th className="px-4 py-2">Sku</th>
                </tr>
              </thead>
              <tbody>
                {ProductInfo &&
                  ProductInfo.map((entry, index) => (
                    <tr key={index} className="border-b">
                      <td className="px-4 py-2 text-center border-r">
                        {entry.product_id}
                      </td>
                      <td className="px-4 py-2 text-center border-r">
                        {entry.quantity}
                      </td>
                      <td className="px-4 py-2 text-center border-r">
                        {entry.sku}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}


        {/* Message Alert */}
        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </div>
  );
};

export default WareHouseStudioRestock;
